module.exports = __webpack_public_path__ + "img/Group368.e36b58b.png";